import { Crown, Rocket, Camera, Wallet, Trophy } from "lucide-react";

const ICONS = {
  creator_of_the_month: Crown,
  fastest_rising: Rocket,
  best_ugc: Camera,
  highest_earning: Wallet,
};

function monthLabel(m) {
  try {
    const [y, mm] = m.split("-").map(Number);
    return new Date(y, mm - 1, 1).toLocaleDateString(undefined, { month: "short", year: "numeric" });
  } catch { return m; }
}

export default function HOFBadges({ badges = [] }) {
  if (!badges?.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="hof-badges">
      {badges.map((b, i) => {
        const Icon = ICONS[b.category] || Trophy;
        return (
          <span
            key={`${b.month}-${b.category}-${i}`}
            title={`${b.category_label} · ${monthLabel(b.month)}`}
            className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full nexus-gradient text-white font-bold shadow-[0_0_15px_rgba(157,78,221,0.4)]"
            data-testid={`hof-badge-${b.category}-${b.month}`}
          >
            <Icon className="h-3 w-3" />
            {b.category_label}
            <span className="opacity-70">· {monthLabel(b.month)}</span>
          </span>
        );
      })}
    </div>
  );
}
